/**
 * DeleteConfirmDialog 컴포넌트 - 회사 삭제 확인 다이얼로그
 */

import { Trash2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import type { Company, CompanyTranslations } from './types';

interface DeleteConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company: Company | null;
  onConfirm: () => void;
  translations: CompanyTranslations;
}

export function DeleteConfirmDialog({
  open,
  onOpenChange,
  company,
  onConfirm,
  translations: t
}: DeleteConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-background border-border">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground flex items-center gap-2">
            <Trash2 className="w-5 h-5 text-destructive" />
            {t.deleteConfirmTitle}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-foreground-muted">
            {t.deleteConfirmMessage}
            {company && (
              <div className="mt-3 p-3 bg-muted rounded-md">
                <p className="font-semibold text-foreground">
                  {company.name}
                </p>
                <p className="text-sm text-muted-foreground mt-1">
                  {company.rfc}
                </p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-muted text-foreground hover:bg-muted/80 border-0">
            {t.cancel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive hover:bg-destructive/90 text-white"
          >
            {t.confirmDelete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
